import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useCacheConfig } from 'legacyfrontend/contexts/CacheConfigContext';
import { selectIsHotelSearcherEnabled } from 'legacyfrontend/redux/selectors/application-selectors';
import { isClient } from 'legacyfrontend/helpers/ssr-helper';


const InternalHotelsRouteGuard = ({ children }) => {
  const { accionesAplicacion } = useCacheConfig();
  const internalHotelsEnabled = useSelector(selectIsHotelSearcherEnabled);

  const externalHotelUrl = accionesAplicacion.find(
    (accion) => accion?.name === 'hoteles' && accion?.activo === true && accion?.url
  )?.url;

  useEffect(() => {
    if (!internalHotelsEnabled && externalHotelUrl && isClient) {
      window.location.assign(externalHotelUrl);
    }
  }, [externalHotelUrl, internalHotelsEnabled]);

  if (!internalHotelsEnabled) {
    return null;
  }

  return children;
};

export default InternalHotelsRouteGuard;
